/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER';
export const FETCH_USER_ENTITLEMENT = 'FETCH_USER_ENTITLEMENT';
export const FETCH_ADMINS = 'FETCH_ADMINS';
export const FETCH_YOURWORK_IMAGES = 'FETCH_YOURWORK_IMAGES';
export const FETCH_APPS_BASED_AUTORANKER = 'FETCH_APPS_BASED_AUTORANKER';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const FETCH_USER_PRODUCT_ENTITLEMENTS = 'FETCH_USER_PRODUCT_ENTITLEMENTS';
export const FETCH_CCSTORAGE_RESULTS = 'FETCH_CCSTORAGE_RESULTS';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_RAW_PROFILE = 'SET_RAW_PROFILE';
export const SET_PROFILE_FETCH_FINISHED = 'SET_PROFILE_FETCH_FINISHED';
export const SET_PROFILE_TIMEOUT_OR_ERROR = 'SET_PROFILE_TIMEOUT_OR_ERROR';
export const SET_LEFTNAV_OPEN = 'SET_LEFTNAV_OPEN';
export const SET_FORCE_HIDE_MENU = 'SET_FORCE_HIDE_MENU';
export const SET_FORCE_HIDE_NAVBAR = 'SET_FORCE_HIDE_NAVBAR';
export const SET_FORCE_HIDE_LANGUAGE_SWITCHER = 'SET_FORCE_HIDE_LANGUAGE_SWITCHER';
export const SET_FORCE_HIDE_LEARN_HOME = 'SET_FORCE_HIDE_LEARN_HOME';
export const SET_MAIN_CONTAINER_OVERLAY = 'SET_MAIN_CONTAINER_OVERLAY';
export const SET_BACKGROUND_HOME = 'SET_BACKGROUND_HOME';
export const SET_PAGE_VISIT_COUNT = 'SET_PAGE_VISIT_COUNT';
export const SET_THOR_PRODUCT_LIST = 'SET_THOR_PRODUCT_LIST';
export const SET_BOOTSTRAP_COMPLETED = 'SET_BOOTSTRAP_COMPLETED';
export const SET_RECENT = 'SET_RECENT';
export const SET_LASTTAB = 'SET_LASTTAB';
export const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG';
export const SET_COACHMARK = 'SET_COACHMARK';
export const SET_FINISH_TOUR = 'SET_FINISH_TOUR';
export const GET_FINISH_TOUR = 'GET_FINISH_TOUR';
export const SEARCH_QUERY = 'SEARCH_QUERY';
export const SET_MODAL_TRIGGER = 'SET_MODAL_TRIGGER';
export const SET_DIALOG_KEY = 'SET_DIALOG_KEY';
export const SET_SEARCH_REFERRER = 'SET_SEARCH_REFERRER';
export const SET_ANALYTICS_OPTIN = 'SET_ANALYTICS_OPTIN';
export const LIBRARIES_FETCH_SUCCESS = 'LIBRARIES_FETCH_SUCCESS';
export const LIBRARIES_FETCH_FAIL = 'LIBRARIES_FETCH_FAIL';
export const LIBRARIES_FETCHING = 'LIBRARIES_FETCHING';
export const LIBRARY_CREATED = 'LIBRARY_CREATED';
export const SET_UCS_FETCH_FINISHED = 'SET_UCS_FETCH_FINISHED';
export const SET_UCS_TIMEOUT_OR_ERROR = 'SET_UCS_TIMEOUT_OR_ERROR';
export const SET_UCS_QUICKLINKS = 'SET_UCS_QUICKLINKS';
export const SET_CCPROJECTS_FINISHED = 'SET_CCPROJECTS_FINISHED';
export const SET_CCPROJECTS_TIMEOUT_OR_ERROR = 'SET_CCPROJECTS_TIMEOUT_OR_ERROR';
